module.exports = __webpack_public_path__ + "img/验证成功.80f2658b.png";